import React, { useState, useContext } from 'react';
import './Register.scss'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import loginBack from '../../assets/login.png'
import askweiLogo from '../../assets/logo.png'
import showLogo from '../../assets/show.png'
import notShowLogo from '../../assets/notShow.png'
import { REACT_APP_WORKING_URL } from '../../Constants'
import Agreement from '../../components/Agreement/Agreement';
import StoredUserContext from '../../context/StoredUserContext';

function GoogleRegisterComponent() {
  const navigate = useNavigate();
  const [checkbox, setCheckbox] = useState(false);
  const [contextUser, setContextUser] = useContext(StoredUserContext);
  const [show, setShow] = useState(false);

  const apiUrl = REACT_APP_WORKING_URL

  const [user, setUser] = useState({
    user_name: "",
    password: "",
    email: "",
    nick_name: "",
    is_verified: 0,
    security_level: 1,
    avatar_url: "",
    bio: "",
    phone_number: "",
    rePassword: ""
  })

  const handleRegister = (e) => {
    console.log('checkbox', checkbox)
    e.preventDefault();
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!regex.test(user.email) || user.email === '') {
      alert('Please input correct email address!')
    }
    else if (user.password !== user.rePassword) {
      alert("Password and Re-Password do not match.");
    } else if (!checkbox) {
      alert("please check agreement first.");
    } else {
      console.log(typeof localStorage.getItem('tempConvert'))
      const id = localStorage.getItem('tempConvert') ? parseInt(localStorage.getItem('tempConvert')) : null
      axios.post(`${apiUrl}users/createUser`, { ...user, email: user.email.toLowerCase(), user_name: user.user_name.replace(/_/g, ' '), referer: localStorage.getItem('referer'), id: id })
        .then(res => {
          if (res.status == 200) {
            alert("Account created!")
            localStorage.setItem('user', JSON.stringify(res.data))
            setContextUser(res.data);
            const isTempConvert = localStorage.getItem('tempConvert') || JSON.parse(localStorage.getItem('tempConvert'));
            if (isTempConvert) {
              navigate('/public-quiz')
            } else {
              navigate('/pre-home')
            }
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status == 409) {
            alert(err.response.data)
          }
          if (err.response.status == 500) {
            alert("Server internal problem, account created fail！")
          }
        })
    }
  }

  const handleChange = (e) => {
    let sanitizedValue = ""
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };

  return (
    <>
      <img src={loginBack} style={{ width: '100vw', height: '100vh' }} />
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <div className='login' style={{ background: 'rgba(255, 255, 255, 0.8)', height: 'fit-content', borderRadius: '30px', }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={askweiLogo} style={{ height: '88px', width: 'auto', marginBottom: '50px' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
            <h3 style={{ fontSize: '1.25rem', lineHeight: '24px', fontWeight: 500, color: '#4CE39B' }}>Sign up needed before check out!</h3>
          </div>
          <h1 style={{ fontSize: '32px', lineHeight: '37.5px', fontWeight: 700, marginBottom: '12px', }}>sign up</h1>
          <div style={{ borderBottom: '2px dashed #4CE39B', marginBottom: '50px' }} />

          <div className='input-container'>
            <div className='tag'>Your display name (username) </div>
            <div>
              <input type="text" name="user_name" placeholder='xxxxxx' onChange={handleChange} />
            </div>
          </div>
          <div style={{ height: '24px' }} />

          <div className='input-container'>
            <div className='tag'>Enter your email address</div>
            <div>
              <input type="text" name="email" placeholder='example@weieducation.ca' onChange={handleChange} />
            </div>
          </div>
          <div style={{ height: '24px' }} />

          <div className='input-container'>
            <div className='tag'>Enter your password</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <input type={show ? "text" : "password"} name="password" onChange={handleChange} placeholder='********'/>
              <img src={show ? notShowLogo : showLogo} style={{ width: '21px', height: '15px', color: 'black' }} onClick={() => { setShow(!show) }} />
            </div>
          </div>
          <div style={{ height: '24px' }} />

          <div className='input-container'>
            <div className='tag'>Enter your password</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <input type={show ? "text" : "password"} name="rePassword" onChange={handleChange} placeholder='********'/>
              <img src={show ? notShowLogo : showLogo} style={{ width: '21px', height: '15px', color: 'black' }} onClick={() => { setShow(!show) }} />
            </div>
          </div>
          <div style={{ height: '24px' }} />

          <div>
            <Agreement checkbox={checkbox} setCheckbox={setCheckbox} />
          </div>
          <div style={{ height: '64px' }} />

          <button onClick={handleRegister} style={{border: 'none', color: 'white', backgroundColor: '#4CE39B', width: '100%', height: '38px', borderRadius: '4px',  fontWeight: 'bold'}}>Register</button>

          <div className='d-flex justify-content-start'>
          </div>
          <div style={{ height: '50px' }} />

          <div className='d-flex justify-content-center'>
            <span style={{fontSize: '0.75rem', fontWeight: 600}}>Already Have An Account?</span>&nbsp;&nbsp;<a style={{ textDecoration: "none", fontSize: '0.75rem', fontWeight: 600, color: '#4CE39B' }} href='/login'>Log in!</a>
          </div>

        </div>
      </div>
    </>

  );
}

// const mapStateToProps = (state) => ({
//   loginUser: state.user,
// });

// const mapDispatchToProps = {
//   Login,
// };

// export default connect(mapStateToProps, mapDispatchToProps)(GoogleRegisterComponent);
export default (GoogleRegisterComponent);